import { Component, Input } from '@angular/core';

@Component({
  selector: 'site-leadFilmCriticComponent',
  templateUrl: './leadFilmCriticComponent.component.html',
  styleUrls: ['./leadFilmCriticComponent.component.css']
})
export class LeadFilmCriticComponent {
  @Input()
  displayName: string;
  @Input()
  role: string;
  @Input()
  universityLike: string;
  @Input()
  universityName: string;
  @Input()
  graduationYear: number;
  @Input()
  degree1: string;
  @Input()
  degree2: string;
  @Input()
  bio: string;
  @Input()
  filmLength: string;
  @Input()
  favFilm: string;
  @Input()
  favFilmYear: number;
  @Input()
  favMovie: string;
  @Input()
  favMovieYear: number;
  @Input()
  associationName: string;
  @Input()
  leadCriticImage: string;
  @Input()
  associationList: string[];
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/leadFilmCriticComponent/leadFilmCriticComponent.component.ts